import withSequenceState from 'components/hoc/withSequenceState';
import { WithSequenceStatePropsType } from 'components/hoc/withSequenceState';
import { CardProps } from 'components/molecules/Card';
import CardDetailRecipe from 'components/molecules/Card/Detail/Recipe';
import { CardDetailPropsType } from 'components/molecules/Card/Fragments/CardDetail';
import Sequences from 'defs/sequences';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
	actionCreators,
	getKcalFromSelectedContent,
	getMenuTypeFilterTagId,
	getNutritionFromSelectedContent,
	getTotalDurationFormattedFromSelectedContent,
	getTotalDurationFromSelectedContent,
	RootStateType,
} from 'store/programItems';
import { actionCreators as transientPoolAC } from 'store/transientPoolState';

export type StateToPropsType = CardDetailPropsType & {
	title: CardProps['title'];
	energy: ReturnType<typeof getKcalFromSelectedContent>;
	totalDuration: ReturnType<typeof getTotalDurationFromSelectedContent>;
	totalDurationFormatted: ReturnType<typeof getTotalDurationFormattedFromSelectedContent>;
	nutrition: ReturnType<typeof getNutritionFromSelectedContent>;
	isDone: boolean;
	contentTypeExternalId: any;
	menuTypeFilterTagId: ReturnType<typeof getMenuTypeFilterTagId>;
};
export type DispatchToPropsType = typeof actionCreators & {
	doSetProgramItemRef: typeof transientPoolAC.doSetProgramItemRef;
	doSetPersistentFilter: typeof transientPoolAC.doSetPersistentFilter;
};

const mapStateToProps = (state: RootStateType, ownProps: CardDetailPropsType): StateToPropsType & any => {
	const selectedContent = ownProps.parentProps;

	return {
		...ownProps,
		contentTypeExternalId: ownProps.id,
		title: selectedContent.title,
		energy: getKcalFromSelectedContent(selectedContent as any),
		totalDuration: getTotalDurationFromSelectedContent(selectedContent as any),
		totalDurationFormatted: getTotalDurationFormattedFromSelectedContent(selectedContent as any),
		nutrition: getNutritionFromSelectedContent(selectedContent as any),
		isDone: false,
		menuTypeFilterTagId: getMenuTypeFilterTagId(state, ownProps.id),
	};
};

const mapDispatchToProps = (dispatch): DispatchToPropsType => {
	return bindActionCreators(
		{
			...actionCreators,
			doSetProgramItemRef: transientPoolAC.doSetProgramItemRef,
			doSetPersistentFilter: transientPoolAC.doSetPersistentFilter,
		},
		dispatch
	);
};

export type ContainerCardDetailRecipeFavoritePropsType = CardDetailPropsType &
	StateToPropsType &
	DispatchToPropsType &
	WithSequenceStatePropsType;

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withSequenceState(CardDetailRecipe, [Sequences.CARD_IS_CHECKING]) as any);
